/**
 * Whether the bar between the sequence and the map is being dragged. The map
 * holds off resizing (and so loading tiles) until the drag ends, which keeps
 * the drag smooth; SPLIT_DRAG_END_EVENT tells it to catch up.
 */
export const SPLIT_DRAG_END_EVENT = "sequence-split-drag-end";

let dragging = false;

export const isSplitDragging = () => dragging;

export function setSplitDragging(next: boolean) {
  if (dragging === next) return;
  dragging = next;
  if (!next) window.dispatchEvent(new Event(SPLIT_DRAG_END_EVENT));
}
